import React from "react";
import OrderSummary from "../../components/menu/orderSummary";
import { UserSearch } from "../../components/userSearch";


export const Checkout = () => {
  return (
    <>
      <div className="flex flex-row justify-between gap-4">
        {/* Left Side: User Search */}
        <div className="w-full">
          <UserSearch isCheckout={true} />
        </div>

        {/* Right Side: Address Form (Only Shows When Needed) */}
        <OrderSummary buttonText="Complete Order" />
      </div>
    </>
  );
};
